const buildResponse = ({ data, status, statusText }) => (
  {
    data,
    status,
    message: statusText,
  }
);

export default buildResponse;
